// 当前官网提交信息标识
export const CURRENT_WEBSITE_SUBMIT_FLAG = 1

// 算力提交标识
export const COMPUTED_SUBMIT_FLAG = 2



// WEBPACK FOOTER //
// ./src/utils/constants.js